import { api } from '../../../../redux/setupAxios';
import { dateToTimestamp } from '../../../helper';

const CHALLENGES_URL = 'challenges';

export const fetchChallenges = async ({ from, to, ...params }) => {
	from = dateToTimestamp(from, 0);
	to = dateToTimestamp(to, Date.now());

	try {
		const { data } = await api.get(`${CHALLENGES_URL}`, {
			params: {
				...params,
				fromTs: from,
				toTs: to,
			},
		});
		return data;
	} catch (err) {
		return [];
	}
};

export const createChallenge = async challenge => {
	const { data } = await api.post(`${CHALLENGES_URL}`, {
		...challenge.announcement,
		from: dateToTimestamp(challenge.announcement.from),
		to: dateToTimestamp(challenge.announcement.to),
		items: challenge.items?.map(({ selected, ...item }) => item) || [],
	});
	challenge._id = data._id;
	return challenge;
};

export const updateChallenge = async challenge => {
	return await api.put(`${CHALLENGES_URL}/${challenge._id}`, {
		...challenge,
		from: dateToTimestamp(challenge.from),
		to: dateToTimestamp(challenge.to),
		items: challenge.items.map(({ selected, ...item }) => item),
	});
};

export const deleteChallenge = async challenge => {
	return await api.delete(`${CHALLENGES_URL}/${challenge._id}`);
};

export const searchItems = async ({ key, merchantId }) => {
	try {
		const { data } = await api.get(`${CHALLENGES_URL}/items`, {
			params: {
				key,
				merchantId,
			},
		});
		return data || [];
	} catch (err) {
		return [];
	}
};
